module.exports = __webpack_public_path__ + "img/btn_armor_off.8e470b87.svg";